module.exports = {
      id: "technology-usage",
      viewBox: "0 0 22.958 22.633",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#technology",
      toString: function () {
        return this.url;
      }
    }